import {GooglePlacesType} from 'desktop/components/addressField/addressField.types';
import {AddressFormItemType} from 'desktop/types/addressType';

/**
 * Perform decomposition of address components from Google and returns results
 * @param {VoidFunctionType} modifier - Modifier for address received form Google
 * @param {string} address - Address string received from form
 * @returns {ProcessedGoogleAddressComponentsType} - Processed address components from Google
 */
export const getAddressComponents = (places: GooglePlacesType) => {
    const components: {[key: string]: {shortName: string; longName: string}} = {};
    const {address_components: addressComponents} = places;
    addressComponents?.forEach(component => {
        components[component.types[0]] = {
            longName: component.long_name,
            shortName: component.short_name,
        };
    });
    return components;
};

export type GooglePlacesAssociationType = {
    fieldName: keyof AddressFormItemType;
    placeLabel: Array<string>;
    nameType: string;
};

export const googlePlacesAssociations: Array<GooglePlacesAssociationType> = [
    {
        fieldName: 'city',
        nameType: 'longName',
        placeLabel: ['administrative_area_level_2', 'neighborhood', 'locality'],
    },
    {fieldName: 'state', nameType: 'longName', placeLabel: ['administrative_area_level_1']},
    {fieldName: 'postal', nameType: 'longName', placeLabel: ['postal_code', 'postal_code_suffix']},
    {fieldName: 'country', nameType: 'shortName', placeLabel: ['country']},
    {fieldName: 'address', nameType: 'longName', placeLabel: ['street_number', 'route']},
];
